import React, { useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const Footer = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  return (
    <div className="footer text-center">
      <bootstrap.Row>
        <bootstrap.Col>
          <p className="text-muted">{t("layout.forAssistance")}</p>
        </bootstrap.Col>
      </bootstrap.Row>
    </div>
  );
};
